import React, { Component } from 'react';
import axios from 'axios';
import Autosuggest from '@UI/Autosuggest';
import ClearButton from '@Components/ClearButton';
import { injectIntl } from 'react-intl';
import t from 'prop-types';

class OccupationField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      occupations: [props.searchParams.occupation],
      occupation: props.searchParams.occupation,
    };
  }

  /**
   * Handle browser history back cases.
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    const { searchParams } = this.props;
    if (searchParams.occupation !== prevProps.searchParams.occupation) {
      this.setState({
        occupation: searchParams.occupation,
      });
    }
  }

  /**
   * Handle Occupation field updates.
   * @param value {String}
   */
  onOccupationChange = (value) => {
    if (value) {
      axios.get(`${process.env.REACT_APP_APIGEE_LAMBDA_ENDPOINT}/occupations-autocomplete`, {
        params: {
          apikey: typeof window !== 'undefined' ? window.apigeeKey : '',
          text: value.trim(),
          language: this.props.intl.locale,
        },
      }).then((response) => {
        const suggestions = response.data ? response.data.data : [];
        this.setState({ occupations: suggestions });
        return suggestions;
      }).catch(() => {
        this.setState({ occupations: [] });
        return [];
      });
    } else {
      this.setState({ occupations: [] });
    }
  };

  /**
   * Clear occupation state.
   */
  clearOccupationField = () => {
    this.setState({ occupation: '', occupations: [] });
  };

  render() {
    const {
      intl,
      cssClasses,
      id,
      highlightError,
      renderError,
    } = this.props;

    const { occupation, occupations } = this.state;

    return (
      <div className={`form-group ${cssClasses} ${highlightError}`}>
        <div
          className="form-group__input form-group__input--button clearable-input"
          data-rs-clearable
        >
          <Autosuggest
            name="occupation"
            id={id}
            required
            placeholder={intl.formatMessage({ id: 'Form.OccupationPlaceholder' })}
            label={intl.formatMessage({ id: 'Form.OccupationLabel' })}
            initialValue={occupation}
            items={occupations}
            config={{ skipFilter: true }}
            data-rs-input-highlight
            onChange={this.onOccupationChange}
            onSelectItem={this.onOccupationChange}
            noResultsText={intl.formatMessage({ id: 'Form.Autocomplete.NoResults' })}
          />
          <ClearButton clearField={this.clearOccupationField} />
          {renderError}
        </div>
      </div>
    );
  }
}

OccupationField.propTypes = {
  cssClasses: t.string,
  highlightError: t.string,
  id: t.string.isRequired,
  renderError: t.oneOfType([t.element, t.string]),
  searchParams: t.shape({
    occupation: t.string,
  }),
};

OccupationField.defaultProps = {
  cssClasses: '',
  highlightError: '',
  renderError: '',
  searchParams: {
    occupation: '',
  },
};

export default injectIntl(OccupationField);
